<template>
  <div class="act">
    <img
      class="queryBtn"
      src="@/assets/GuangzhouUnicomImg/new/queryBtn.png"
      alt=""
      @click="queryOrder"
    />
    <img
      class="kefuBtn"
      src="@/assets/GuangzhouUnicomImg/new/service.png"
      alt=""
      @click="openKefu"
    />
    <div class="bottomBtn" v-show="bottomBtn">
      <img
        @click="onSubmit"
        class="bottomBtnImg"
        src="@/assets/GuangzhouUnicomImg/new/lqBtn2.png"
        alt=""
      />
    </div>
    <div class="content">
      <div class="contentBox2">
        <div class="userInfo">
          <van-form @submit="onSubmit" :label-width="0">
            <div class="form-item">
              <div class="form-label form-label__reqiured">姓名</div>
              <van-field
                class="form-field"
                v-model="cardName"
                name="cardName"
                placeholder="与身份证一致（已加密）"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">身份证号</div>
              <van-field
                class="form-field"
                v-model="cardNo"
                name="cardNo"
                maxlength="18"
                placeholder="仅用于本次业务（已加密）"
                :rules="[
                  {
                    validator: sfzValidator,
                    message: '请输入正确身份证号码',
                  },
                ]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">联系电话</div>
              <van-field
                class="form-field"
                v-model="contactsMobile"
                maxlength="11"
                name="contactsMobile"
                placeholder="收货手机号码（已加密）"
                :rules="[{ pattern, message: '请输入正确手机号码' }]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">号码归属地</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="cardAttribution"
                :value="cardAttribution"
                placeholder="请选择归属地区省市"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">收货城市</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="contactsCity"
                :value="contactsCity"
                placeholder="请选择收货区省市"
                @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList"
                  @confirm="onConfirm"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">详细地址</div>
              <van-field
                class="form-field"
                v-model="contactsAddress"
                name="contactsAddress"
                placeholder="请输入详细的收货地址"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">免费选号</div>
              <van-field
                readonly
                clickable
                class="form-field"
                :value="comboMobile"
                name="comboMobile"
                placeholder="请选择号码"
                @click="numGuessSelect()"
              />
            </div>

            <div class="activeInfo">
              <div class="activeLeft">预存300元即可享受资费优惠</div>
            </div>
            <div
              class="dealText"
              v-if="dealTextList && dealTextList.length > 0"
            >
              <div class="read">
                <van-checkbox v-model="checkDeal" icon-size="16px" />
                我已阅读并同意
                <span
                  class="deal"
                  @click="toUnicomDeal(item.components)"
                  v-for="(item, index) in dealTextList"
                  :key="index"
                  ><span class="xy">《{{ item.name }}》</span>
                </span>
              </div>
            </div>
          </van-form>
          <div class="btn" ref="sumitBtm" @click="onSubmit">
            <img
              class="lqBtn"
              src="@/assets/GuangzhouUnicomImg/new/lqBtn2.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="contentBox1">
        <div class="zfxqInfo">
          <div class="container">
            <div class="header">资费详情</div>
            <div class="content">
              <div class="zfxqTable">
                <div class="zTr">
                  <div class="zTh">月费</div>
                  <div class="zTd">
                    <span class="blueText">90元/月</span>（原资费129元/月）
                  </div>
                </div>
                <div class="zTr">
                  <div class="zTh">流量</div>
                  <div class="zTd">
                    <span class="blueText"> 30G </span>
                  </div>
                </div>
                <div class="zTr">
                  <div class="zTh">语音</div>
                  <div class="zTd">
                    <span class="blueText">500分钟</span>
                  </div>
                </div>
                <div class="zTr">
                  <div class="zTh">宽带</div>
                  <div class="zTd">
                    <span class="blueText">500M</span>
                  </div>
                </div>
              </div>
              <!-- <div class="section">
              <h3>活动说明：</h3>

              <p>
                1、专属流量应用包含:腾讯系和非腾讯系,具体包括微信、手机OO、腾讯新闻、腾讯视频、QQ音乐、QO邮箱、企业邮箱，王者荣耀、英雄联盟手游、OO游戏、快手、美团APP、美团外卖、小红书、酷狗音乐、喜马拉雅等近200款APP。
              </p>
              <p>
                2、具体查询路径如下:
                关注微信公众号“王卡助手”--服务--专属应用中心--专属应用推荐--查看全部应用。
              </p>
            </div> -->
            </div>
          </div>
        </div>
        <div class="container">
          <div class="header">常见问题</div>
          <div class="content">
            <div class="section">
              <p>
                1、本业务向年满18-60周岁并使用身份证的用户办理，无身份证、黑名单用户等特殊群体无法办理，请知悉。
              </p>
              <p>
                2、此卡禁止用于电话销售/推销/金融等类似骚扰诈骗等形式的用途，一旦被投诉或系统监测到会导致停机，无法继续享受优惠或使用
              </p>
              <p>
                3、产品及相关优惠活动仅限指定互联网渠道销售，产品最终名称以联通系统展示为准。在使用过程中若遇任何问题，可致电18594033399/17502020112客服热线咨询。
              </p>
              <p>
                4、如需销户，请持本人身份证原件，前往中国联通营业厅咨询办理。如合约期内销户，将产生违约金，具体违约金额以中国联通营业厅系统查询为准。
              </p>
            </div>
          </div>
        </div>
      </div>
      <img
        class="bottomImg"
        src="@/assets/GuangzhouUnicomImg/new/bottomImg.png"
        alt=""
      />

      <van-dialog v-model="showMobilePicker" :showConfirmButton="false">
        <div class="numSelBox">
          <div class="numClose">
            <van-search
              v-model="searchVal"
              placeholder="请输入号码"
              show-action
              @search="numGuessSelect"
              class="searchInput"
            >
              <div slot="action" @click="numGuessSelect">搜索</div>
            </van-search>
            <div class="closeIcon" @click="showMobilePicker = false">
              <van-icon name="close" size="24" />
            </div>
          </div>
          <div class="numBox" v-if="numList.length > 0">
            <!-- <div
            v-for="item in numList"
            :key="item"
            class="numContent"
            @click="selcetNum(item)"
          >
            <div>{{ item.numId }}</div>
            <div class="redText">
              合约期{{ item.timeDurPro }}个月,预存金额{{
                item.advancePay
              }},低消{{ item.lowCostPro }}
            </div>
          </div> -->

            <div
              class="numContent"
              v-for="item in numList"
              :key="item.numId"
              @click="selcetNum(item)"
            >
              <div class="conentBox">
                <div class="numberInfo numberBox">
                  <div class="number">{{ item.numId }}</div>
                  <div class="beautiful">靓</div>
                </div>
                <div class="numberInfo">
                  <div class="infoLabel">预存款</div>
                  <div class="infoValue">{{ item.advancePay }}元</div>
                </div>
                <div class="numberInfo">
                  <div class="infoLabel">协议期</div>
                  <div class="infoValue">{{ item.timeDurPro }}个月</div>
                </div>
                <div class="numberInfo">
                  <div class="infoLabel">月承诺通信费用</div>
                  <div class="infoValue">{{ item.lowCostPro }}元</div>
                </div>
              </div>
            </div>
          </div>
          <div class="numBox" v-else>
            <div class="noNum">未找到该号码</div>
          </div>
          <div class="numBtn">
            <van-button
              icon="replay"
              type="default"
              native-type="button"
              @click="numGuessSelect()"
              >换一换</van-button
            >
          </div>
        </div>
      </van-dialog>
    </div>
    <dialogTips
      :text="dialogTips.text"
      :icon="dialogTips.icon"
      :iconColor="dialogTips.iconColor"
      :show="dialogTips.show"
      :confirmButtonText="dialogTips.confirmButtonText"
      @confirm="confirmTips"
    ></dialogTips>
  </div>
</template>

<script>
import {
  Form,
  Field,
  Popup,
  Picker,
  Dialog,
  Icon,
  Checkbox,
  Button,
  Search,
} from "vant";
import areaData from "../../public/static/areaData.json";
import operatorData from "../../public/static/operatorData.json";
import { http } from "@/api/http";
import { accDiv } from "@/utils/utils";
import dialogTips from "@/pages/components/dialogTips";
// import { deepClone } from "@/utils/utils";
// import moment from "moment";
// import Countdown from "./components/Countdown.vue";
export default {
  name: "BeautifulNumber",
  components: {
    vanForm: Form,
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker,
    vanButton: Button,
    vanIcon: Icon,
    vanCheckbox: Checkbox,
    vanSearch: Search,
    [Dialog.Component.name]: Dialog.Component,
    dialogTips,
    // Countdown,
  },
  data() {
    return {
      areaList: [],
      comboName: "",
      cardName: "",
      cardNo: "",
      contactsMobile: "",
      cardAttribution: "",
      cardAttributionCode: "",
      comboMobile: "",
      contactsCity: "",
      contactsAddress: "",
      columns: [],
      showArea: false,
      showMobile: "",
      checkDeal: true,
      showPicker: false,
      mapData: [],
      mtBmUid: "",
      spiId: "",
      cardAttributionProvince: "",
      showMobilePicker: false,
      numList: [],
      pattern: /^1[3456789]\d{9}$/,
      // selectCombo: {},
      goodsCode: null,
      dealTextList: [], //协议数据
      areaData: {},
      saleId: null,
      scrollY: 0,
      bottomBtn: false,
      showBtnTop: 0,
      oIndex: 0,
      comboData: {},
      channel: "",
      classOption: {
        singleHeight: 40,
        waitTime: 5000,
      },
      isEnded: false,

      showSetSize: false,
      giftInfo: "",
      sizeIndex: 0,
      mobileObj: {},
      searchVal: "",
      dialogTips: {
        text: "",
        icon: "",
        iconColor: "",
        show: false,
        confirmButtonText: "",
      },
      noClick: false,
    };
  },
  created() {
    this.mtBmUid = localStorage.getItem("mtBmUid");
    this.spiId = localStorage.getItem("gysCode");
    this.saleId = localStorage.getItem("saleId");
    this.oIndex = localStorage.getItem("oIndex");
    this.channel = localStorage.getItem("channel");
    this.columns = [];
    this.columns = operatorData[this.spiId].cardAttribution;
    this.cardAttribution = this.columns[this.oIndex].text;
    this.cardAttributionProvince = this.columns[this.oIndex].value;
    this.cardAttributionCode = this.columns[this.oIndex].value;
    this.areaList = [];
    this.areaList.push(areaData["440100"]);
    this.comboData = operatorData[this.spiId].comboList[this.oIndex];
    this.comboName = this.comboData.comboName;
    if (this.spiId == "gzuni0000000001") {
      this.cardAttributionProvince = "440000";
    }

    this.dealTextList = [
      {
        name: "入网协议",
        components: "unicomDeal9",
      },
      {
        name: "用户隐私协议",
        components: "ysxy",
      },
    ];
    this.simViewLogAdd();
    // this.showMobilePicker = true;
    // this.numGuessSelect();
  },
  watch: {
    cardAttribution(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.comboMobile = "";
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      const height = this.$refs.sumitBtm.offsetTop;
      this.showBtnTop = height + window.innerHeight;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    confirmTips() {
      this.dialogTips.show = false;
      this.$forceUpdate();
      if (this.dialogTips.icon == "success") {
        window.location.reload();
      }
    },
    async simViewLogAdd() {
      let params = {
        mtBmUid: "BeautifulNumber",
        spiId: this.spiId,
        clickName: "BeautifulNumber",
        uid: "",
      };
      http("simViewLogAdd", params);
    },

    openSetMeal() {
      this.showSetSize = true;
    },
    ended() {
      this.isEnded = true;
    },
    initAreaList2() {
      let pArr = [];
      let cArr = [];
      let pObj = {};
      let cObj = {};
      this.areaList.map((v) => {
        v.children.map((val) => {
          cArr = [];
          val.children.map((value) => {
            cObj = {
              text: value.text,
              code: value.code,
            };
            cArr.push(cObj);
          });
          pObj = {
            text: val.text,
            code: val.code,
            children: cArr,
          };
          pArr.push(pObj);
        });
      });
      // console.log("pArr =>", pArr);
      this.areaList2 = [
        {
          text: "",
          code: "0",
          children: pArr,
        },
      ];
    },
    openKefu() {
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc2ef46aff0a7d85a6";
    },
    queryOrder() {
      window.location.href =
        "https://m.10010.com/myorder/?isNew=1&entrycode=W002";
    },

    async onSubmit(values) {
      if (this.noClick) {
        return;
      } else if (!this.checkDeal) {
        this.$toast("请阅读并同意协议");
        return;
      } else if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      } else if (!this.comboMobile && this.showMobile == "true") {
        this.$toast("请选择号码");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货区地址");
        return;
      } else if (!this.contactsAddress) {
        this.$toast("请输入详细的收货地址");
        return;
      } else if (this.contactsAddress.length < 4) {
        this.$toast("详细地址长度不少于4位");
        return;
      } else if (this.zpActivety && !this.giftInfo) {
        this.$toast("请选择赠品尺码");
        return;
      }
      let params = {
        comboLevel: this.comboData.comboLevel,
        comboName: this.comboData.comboName,
        // cardAttribution: this.areaData2.cCode,
        cardAttribution: this.cardAttributionCode,
        goodsName: operatorData[this.spiId].goodsName,
        mtBmUid: this.mtBmUid,
        spiDepartId: this.spiId,
        comboMobile: this.comboMobile,
        cardAttributionProvince: this.cardAttributionProvince,
        // cardAttributionProvince: this.areaData2.pCode,
        contactsProvince: this.areaData.pName, // 省
        contactsProvinceCode: this.areaData.pCode, // 省
        contactsCity: this.areaData.cName, // 市
        contactsCityCode: this.areaData.cCode, // 市
        contactsArea: this.areaData.aName, // 区
        contactsAreaCode: this.areaData.aCode, // 区
        comboCode: this.comboData.comboCode,
        goodsCode: this.comboData.goodsCode,
        saleId: this.saleId,
        cardName: this.cardName,
        cardNo: this.cardNo,
        channelCode: "",
        checkCode: "",
        contactsAddress: this.contactsAddress,
        contactsMobile: this.contactsMobile,
        feeType: "",
        numberId: "",
        registerMobile: "",
        tractAddress: "",
        uid: "",
        channel: this.channel,
        niceNum: true,
      };
      if (this.zpActivety) {
        params = {
          ...params,
          giftInfo: this.giftInfo,
        };
      }
      this.noClick = true;
      let paramsData = Object.assign(values, params);
      const { code, message } = await http("simOrder", paramsData);
      this.noClick = false;
      if (code == 200) {
        this.dialogTips = {
          text: "提交成功，请留意快递信息，收到的手机号必须与您选择的号码一致，不一致将无法享受套餐相应优惠或活动赠送礼品，如发现号码不一致，请立即联系在线客服处理",
          icon: "success",
          iconColor: "#07C160",
          show: true,
          confirmButtonText: "确定",
        };
      } else {
        this.dialogTips = {
          text: message,
          icon: "warning",
          iconColor: "#FF4444",
          show: true,
          confirmButtonText: "关闭",
        };
      }
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.scrollY >= this.showBtnTop) {
        if (!this.bottomBtn) {
          this.bottomBtn = true;
        }
      } else {
        if (this.bottomBtn) {
          this.bottomBtn = false;
        }
      }
      // console.log("Scroll Y position:", this.scrollY);
    },
    selcetNum(item) {
      this.comboMobile = item.numId;
      this.mobileObj = item;
      this.showMobilePicker = false;
    },
    selectCity(values, indexs) {
      // console.log("value =>",value)
      // this.cardAttribution = value.text;
      // this.cardAttributionProvince = value.value;

      this.areaData2 = {
        pName:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
      };
      this.cardAttribution = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      this.showPicker = false;
    },
    onConfirm(values, indexs) {
      this.areaData = {
        pName:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
        aName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].text
            : "", //区
        aCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].code
            : "",
      };
      console.log("areaData =>", this.areaData);
      this.contactsCity = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      this.mapData = values;
      this.showArea = false;
    },
    sfzValidator(val) {
      return /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
        val
      );
    },

    async numGuessSelect() {
      if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }
      let params = {
        spiId: this.spiId,
        cityCode: this.cardAttributionCode,
        goodsId: this.comboData.comboCode,
        provinceCode: this.cardAttributionProvince,
        key: this.searchVal,
      };
      // let params = {
      //   spiId: "gzuni0000000001",
      //   cityCode: "440100",
      //   goodsId: "512111235852",
      //   provinceCode: "440000",
      //   key:this.searchVal
      // };

      const { code, result, message } = await http("bNumSelectNice", params);
      if (code !== 200) return this.$toast(message);
      if (code == 200) {
        console.log("result =>", result);
        result.map((v) => {
          if (v.advancePay) {
            v.advancePay = accDiv(v.advancePay, 1000);
          }
          if (v.lowCostPro) {
            v.lowCostPro = accDiv(v.lowCostPro, 1000);
          }
        });
        this.numList = result;
        this.showMobilePicker = true;
      }
    },
    toUnicomDeal(components) {
      this.$router.push({
        name: components,
      });
    },
    getCard() {
      const queryData = Object.assign({}, this.swiperMsg, {
        spiId: this.spiId,
        mtBmUid: this.mtBmUid,
      });
      delete queryData.abstractImg;
      this.$router.push({
        name: "GuangzhouUHanding",
        query: queryData,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/style/GuangzhouUnicom.less";
.act {
  padding-top: 40px;
}
.contentBox1 {
  padding: 0 20px !important;
}
.numSelBox {
  padding: 40px 0;
  box-sizing: border-box;
  // height: 30rem;
  // background-color: red;
  position: relative;
  .numBox {
    width: 100%;
    padding: 10px 5px 40px 5px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    height: 70vh;
    overflow: hidden;
    overflow-y: scroll;
    .noNum {
      width: 100%;
      padding-top: 30px;
      text-align: center;
    }
    .numContent {
      width: 50%;
      padding: 5px;
      box-sizing: border-box;
      .conentBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        border: 1px solid #eee;
        padding: 5px;
        .numberInfo {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          line-height: normal;
          height: 30px;
          font-size: 12px;
          .infoLabel {
            color: #7c777b;
          }

          &.numberBox {
            border-bottom: 1px solid #eee;
            .number {
              font-size: 16px;
            }
            .beautiful {
              background-color: #416cc9;
              color: #fff;
              font-size: 12px;
              padding: 0 5px;
              height: 20px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
  .numClose {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    // height: 40px;
    background-color: #fff;
    // padding: 0.8rem 1.5rem 0.6rem 0.8rem;
    text-align: right;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .searchInput {
      width: 80%;
    }
    .closeIcon {
      width: 10%;
      padding: 5px 10px 15px 5px;
    }
  }
  .numBtn {
    position: absolute;
    left: 0;
    bottom: 0;
    text-align: center;
    background-color: #fff;
    width: 100%;
    padding: 5px 0;
    box-sizing: border-box;
  }
}
</style>
